import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BillingService } from 'src/app/services/billing.service';

@Injectable()
export class ClaimsResolver  {
  constructor(
    private billingService: BillingService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let dwDetails = JSON.parse(sessionStorage.getItem('dwDetails'));
    let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
    let user = JSON.parse(sessionStorage.getItem('userDetails'));

    // Skip DWgetSummary call for pirate ship flow
    const flowType = sessionStorage.getItem('flowType');
    if (state.url.includes('pirate-ship') || flowType === 'pirateship') {
      return of(true);
    }

    if (user && user?.userRoleID && user?.userRoleID == '3') {
      return of(true);
    }

    if (dwDetails) {
      return of(true);
    }
    else if (policyDetails?.policyCountry_Ext == 'US') {
      let request = {
        productSourceSystem: "gw",
        sourceSystemIdentifierName: "PolicyNumber",
        sourceSystemIdentifier: policyDetails?.policyNumber,
        country: "US",
        roleType: "string",
        productType: user && user?.userRoleID == '8' ? "CommerceGuard" : "string",
        productSystem: user && user?.userRoleID == '8' ? "Billiant" : ''
      }
      return this.billingService.DWgetSummary(request).pipe(  //pipe in order to be able to tap
        tap(  //tap to read response before forwarding it to the subscriber
          data => {
            if (data && data?.message == "Success") {
              sessionStorage.setItem('dwDetails', JSON.stringify(data?.data?.wallet));
            }
          }
        )
      );
    }
    else {
      return of(true);
    }
  }
}
